// extracted by mini-css-extract-plugin
module.exports = {"btn-container":"isr_btn-container__2f6Qo","heading":"isr_heading__2zUBJ","refresh-btn":"isr_refresh-btn__27Bjp","upload-history-btn":"isr_upload-history-btn__2fyHr"};